import fetch from 'cross-fetch';
import { FacebookConfirmAction, FacebookConfirmResponse } from './facebook-confirm';

export class RemoteFacebookConfirmAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: FacebookConfirmAction = async (): Promise<FacebookConfirmResponse> => {
		const base: string = this.baseUrl || '';

		const response: Response = await fetch(`${base}/api/auth/facebook/confirm`, {
			mode: 'cors',
			credentials: 'include',
			method: 'POST',
		});

		const text = await response.text();
		const jsonResponse = text ? JSON.parse(text) : {};
		return { ...jsonResponse, status: response.status };
	};
}
